module.exports = __webpack_public_path__ + "static/img/home-banner.7ee7a840.jpg";